import z from 'zod';
import { broadcastAttachmentSchema, broadcastSchema } from './schema';
import { Account } from 'types';
import { Nullable } from 'global';
import {
  BroadcastAudience,
  BroadcastStatus,
  BroadcastToUserStatus,
  BroadcastType,
} from '@trnsact/trnsact-shared-types';

export interface Broadcast {
  broadcastId: string;
  accountId: Nullable<string>;
  type: BroadcastType;
  title: string;
  body?: string;
  bodyPreview?: string;
  status: BroadcastStatus;
  effectiveDateTime: string;
  createdDateTime: string;
  attachments: BroadcastAttachment[];
  account: Nullable<Account>;
  broadcastToUser: BroadcastToUser;
  broadcastAudience?: BroadcastAudience[];
}

export enum BroadcastEditorModes {
  Create = 'Create',
  Edit = 'Edit',
}

export interface ViewBroadcastDialogData {
  broadcastId?: string;
  broadcastPreview?: Broadcast;
}

export interface BroadcastToUser {
  broadcastToUserId?: string;
  broadcastId: string;
  userProfileId: string;
  status: BroadcastToUserStatus;
}

export type BroadcastFormValues = z.infer<typeof broadcastSchema>;

export type BroadcastAttachment = z.infer<typeof broadcastAttachmentSchema>;
